import DAboutFirstBlock from './DAboutFirstBlock'

export default DAboutFirstBlock
